import { Select, Button } from '@panwds/react-ui';
import React, { useMemo } from 'react';
import { v4 } from 'uuid';

const SelectPageSize = ({ onChangePageSize, menuStyle, pageSize, pageSizeOptions, paginationType = 'standard', rowName = 'Rows', dataTestId }) => {
    const labelId = useMemo(() => `table-rows-${v4()}-label`, []);
    const buttonId = useMemo(() => `table-rows-${v4()}-button`, []);
    const memoizedPageSizeOptions = useMemo(() => pageSizeOptions.map((i) => ({ value: i })), [pageSizeOptions]);
    const selectedPageSize = useMemo(() => memoizedPageSizeOptions.find((i) => i.value === pageSize) || null, [memoizedPageSizeOptions, pageSize]);
    const buttonAppearance = paginationType === 'standard' || paginationType === 'alternate' || paginationType === 'user-input'
        ? 'tertiary'
        : 'tertiary-clear';
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { menuStyle: menuStyle, labelId: labelId, toggleButtonId: buttonId, "data-testid": "select-page-size", button: React.createElement(Button, { dataTestId: `${dataTestId}-select-page-size-button`, isMenu: true, appearance: buttonAppearance }, rowName && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "tw-mr-1" }, `${selectedPageSize === null || selectedPageSize === void 0 ? void 0 : selectedPageSize.value} `),
                React.createElement("label", { id: labelId, htmlFor: buttonId, className: "tw-flex tw-space-x-4 tw-leading-loose tw-text-xs" }, rowName)))), defaultPlacement: "top-start", selectedItem: selectedPageSize, items: memoizedPageSizeOptions, onChange: ({ selectedItem }) => {
                const value = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value;
                onChangePageSize(value);
            } })));
};

export { SelectPageSize };
//# sourceMappingURL=SelectPageSize.esm.js.map
